import { Theme } from "@mui/material";

export const bookingHomeStyles = {
  mainContainer: (theme: Theme) => ({
    margin: "20px 20px",
    fontFamily: theme.typography.fontFamily,
  }),
  loaderContainer: { display: "flex", justifyContent: "center" },
  noRecordText: {
    fontSize: "16px",
    textAlign: "center",
  },
  cardsContainer: (isScreenBreak: boolean) => ({
    display: "flex",
    width: "100%",
    maxWidth: "1290px",
    flexDirection: "column",
    marginTop: 3,
    // justifyContent: isScreenBreak ? "center" : "flex-start",
    justifyContent: "center",
    gap: "20px",
    marginLeft: "auto",
    marginRight: "auto",
  }),
};
